import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  maxEntries: 5,
  phrases: [],
};

const getNumberOfUniqueEntries = (arr, maxElements) =>
  [...new Set(arr)].slice(0, maxElements);

export const searchHistorySlice = createSlice({
  name: 'searchHistory',
  initialState,
  reducers: {
    addSearchedPhrase: (state, action) => {
      const phrase = action.payload;
      /* get MAX_SEARCH_HISTORY_ENTRIES unique search entries
       (starting with the payload phrase) */
      state.phrases = getNumberOfUniqueEntries(
        [phrase, ...state.phrases],
        state.maxEntries,
      );
    },
    setMaxNumberOfSearchHistoryEntries: (state, action) => {
      const newMaxEntries = action.payload;
      state.phrases = getNumberOfUniqueEntries(state.phrases, newMaxEntries);
      state.maxEntries = newMaxEntries;
    },
  },
});

export const { addSearchedPhrase, setMaxNumberOfSearchHistoryEntries } =
  searchHistorySlice.actions;
export const selectSearchedPhrases = ({ searchHistory }) =>
  searchHistory.phrases;

export default searchHistorySlice.reducer;
